// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nm-0";
export var fileList = "_nm-2";
export var removeFileButton = "_nm-1";